import { Map, List } from "immutable";
import { StatementPipeline } from "utilities/data-pipelines";
import { STATEMENT_ACTIONS } from "constants/actions";
import { STATE_STATUS } from "constants";
/* eslint-disable no-unused-vars */

const DEFAULT_STATEMENT_STATE = new Map({
    status: STATE_STATUS.UNFETCHED,
    data: new Map({}),
    error: null
});

export default (state = new Map({}), { type, payload, error }) => {
    switch (type) {
    case STATEMENT_ACTIONS.CREATE_STATEMENT:
        if (!state.get(payload.caseId)) {
            return state.set(
                payload.caseId,
                new Map({
                    [payload.bankAccountId]: DEFAULT_STATEMENT_STATE.set(
                        "status",
                        STATE_STATUS.CREATING
                    )
                })
            );
        }
        return state.setIn(
            [payload.caseId, payload.bankAccountId],
            DEFAULT_STATEMENT_STATE.set("status", STATE_STATUS.CREATING)
        );
    case STATEMENT_ACTIONS.CREATED_STATEMENT:
        return state.setIn(
            [payload.caseId, payload.bankAccountId],
            DEFAULT_STATEMENT_STATE.set("status", STATE_STATUS.UNFETCHED)
        );
    case STATEMENT_ACTIONS.DELETED_STATEMENT:
        return state
            .setIn(
                [payload.caseId, payload.bankAccountId, "status"],
                STATE_STATUS.UNFETCHED
            )
            .setIn(
                [payload.caseId, payload.bankAccountId, "data"],
                new Map({})
            );
    case STATEMENT_ACTIONS.FETCH_STATEMENT:
        return state.setIn(
            [payload.caseId, payload.bankAccountId, "status"],
            STATE_STATUS.FETCHING
        );
    case STATEMENT_ACTIONS.FETCHED_STATEMENT:
        return state
            .setIn(
                [payload.caseId, payload.bankAccountId, "status"],
                STATE_STATUS.FETCHED
            )
            .setIn(
                [payload.caseId, payload.bankAccountId, "data"],
                StatementPipeline.run(new List(payload.statement))
            );
    case STATEMENT_ACTIONS.FAILED_FETCH_STATEMENT:
        return state
            .setIn(
                [payload.caseId, payload.bankAccountId, "status"],
                STATE_STATUS.FETCH_FAILED
            )
            .setIn([payload.caseId, payload.bankAccountId, "error"], error);
    case STATEMENT_ACTIONS.UPDATE_STATEMENT:
        return state.setIn(
            [payload.caseId, payload.bankAccountId, "status"],
            STATE_STATUS.UPDATING
        );
    case STATEMENT_ACTIONS.UPDATED_STATEMENT:
        return state
            .setIn(
                [payload.caseId, payload.bankAccountId, "status"],
                STATE_STATUS.UPDATED
            )
            .setIn(
                [payload.caseId, payload.bankAccountId, "data"],
                payload.statement
            );
    case "LOGOUT":
        return DEFAULT_STATEMENT_STATE;
    default:
        return state;
    }
};
